<template>
  <div class="vote-main">
    <w-nav-bar nav_title="编辑投票" @mobileLeftBtn="pageBack" icon="iconx">
      <div slot="rightContent" class="submit-btn" :style="{color:isSub?'#FF6644':'#FFD6CD'}" @click="handleClickSubmit">
        完成
      </div>
    </w-nav-bar>
    <div class="vote-theme">
      <input class="vote-theme-input" placeholder="投票主题" maxlength="25" v-model="vote.name"></input>
    </div>
    <div class="vote-option" v-for="(item,index) in vote.options" :key="`${index}option`">
      <input class="vote-option-input" :placeholder="`选项${index+1}`" maxlength="20"
             v-model="vote.options[index].content"></input>
      <span class="iconfont iconshanchu1 vote-option-delete" v-show="vote.options.length>2"
            @click="handleClickDelete(item,index)"></span>
    </div>
    <div>
      <div class="vote-add-option" v-show="vote.options.length<10" @click="handleClickAddOption">
        <div class="vote-option-add-icon">
          <span class="iconfont iconshanchu1"></span>
        </div>
        <span class="add-text">添加选项（最多 10 项）</span>
      </div>
      <div class="vote-add-option" v-show="vote.options.length==10">
        <span class="add-text">已达到最大选项</span>
      </div>
    </div>
    <div class="flex-start type-box">
      <span class="type-text">单选/多选：</span>
      <div class="type-item" :class="{'text-active':vote.type=='single'}" @click="vote.type='single'">单选</div>
      <div class="type-item" :class="{'text-active':vote.type=='multi'}" @click="vote.type='multi'">多选</div>
    </div>
    <div class="flex-start end-box">
      <span class="type-text">结束时间：</span>
      <div class="end-item" v-for="(item,index) in endList" :key="index+'end'"
           :class="{'text-active':vote.expiry==item.value}" @click="vote.expiry=item.value">
        {{item.name}}
      </div>
    </div>
  </div>
</template>

<script>
  import WNavBar from "../../../components/global/w-navbar"
  import bbs from '../../../api/api-list/bbs'
  import {mapMutations, mapState} from "vuex"

  export default {
    name: "createVote",
    components: {
      WNavBar
    },
    data() {
      return {
        endList: [{name: '12小时', value: 12}, {name: '24小时', value: 24}, {name: '3天', value: 72}, {
          name: '7天',
          value: 168
        }],
        vote: {
          options: [{id: "", content: ""}, {id: "", content: ""}],
          type: "single",
          expiry: 24,//结束时间
          name: "",//主题
        },
        isSub: false,//是否可以提交
        isOngoing: false,//是否正在创建中
      }
    },
    mounted() {

      let vote = this.$store.state.community.vote;
      if (vote != null) {
        this.vote = JSON.parse(JSON.stringify(vote))
        this.isSub = true
        this.isOngoing = false
      }

    },
    methods: {
      ...mapMutations('community', ["setVote"]),
      pageBack() {
        if (this.$store.state.community.vote) {
          let vote = this.$store.state.community.vote
          let {name, expiry, options, type} = this.vote
          if (name != vote.name || expiry != vote.expiry || type != vote.type || options.length != vote.options.length || options.some((item, index) => vote.options[index].id != item.id || vote.options[index].content != item.content)) {
            console.log("重新编辑了")
            this.goBackCheck()
          } else {
            this.$emit("handleClose")
          }
        } else {
          let {name, expiry, options, type} = this.vote
          if (!name && expiry == 24 && type == 'single' && options.every(item => item.id == "" && item.content == "")) {
            this.$emit("handleClose")
          } else {
            this.goBackCheck()
          }
        }
      },
      goBackCheck() {
        this.$createDialog({
          type: 'confirm',
          title: '提示',
          content: '当前内容尚未发布，退出编辑内容将丢失，确认退出？',
          confirmBtn: {
            text: '继续编辑',
            active: true,
            disabled: false,
            href: 'javascript:;'
          },
          cancelBtn: {
            text: '退出',
            active: false,
            disabled: false,
            href: 'javascript:;'
          },
          onConfirm: () => {

          },
          onCancel: async () => {
            this.$emit("handleClose")
          }
        }).show()
      },
      handleClickAddOption() {
        this.vote.options.push({id: "", content: ""})
      },
      handleClickDelete(item, index) {
        this.vote.options.splice(index, 1)
      },
      checkVote() {
        if (this.vote.name != '' && this.vote.options.every(item => item.content != '')) {
          this.isSub = true
        } else {
          this.isSub = false
        }
      },
      async handleClickSubmit() {
        function isRepeat(arr) {
          let hash = {};
          for (let i in arr) {
            if (hash[arr[i]])
              return true;
            hash[arr[i]] = true;
          }
          return false;
        }

        if (!this.isSub || this.isOngoing) {
          return
        }
        if (isRepeat(this.vote.options.map(item => item.content))) {
          this.$createToast({
            txt: '存在重复选项',
            time: 2000,
            type: 'txt'
          }).show()
          return;
        }
        this.isOngoing = true
        try {
          let res = {}
          if (this.$store.state.community.vote) {
            res = await bbs.updateVote(this.$store.state.community.vote.id, this.vote)
          } else {
            res = await bbs.createVote(this.vote)
          }
          if (res.code === 1000) {
            this.$createToast({
              txt: this.$store.state.community.vote ? '编辑成功' : '创建成功',
              time: 500,
              type: 'txt'
            }).show()
            this.setVote(res.data)
            setTimeout(() => {
              this.$emit("handleClose")
            }, 500)
          } else {
            this.$createToast({
              txt: res.message,
              time: 500,
              type: 'txt'
            }).show()
          }
        } finally {
          this.isOngoing = false
        }
      }
    },
    watch: {
      vote: {
        handler(newName, oldName) {
          this.checkVote()
        },
        immediate: true,
        deep: true
      }
    }
  }
</script>

<style scoped lang="scss">
  .vote-main {
    width: 100%;
    height: 100vh;
    background-color: #fff;
    padding: 44px 24px 0;
    position: relative;

    /deep/ .iconx {
      font-weight: 400;
    }

    .submit-btn {
      font-size: 16px;
    }

    input {
      border: none;
      outline: none;
      width: 100%;
    }

    input::placeholder {
      color: #BCBCBC
    }

    .vote-theme {
      border-bottom: 1px solid #F9F9F9;
      padding-bottom: 7px;
      padding-top: 15px;
    }

    .vote-theme-input {
      font-size: 16px;
      line-height: 22px;
      font-weight: 600;
      color: #404040
    }


    .vote-option {
      height: 34px;
      margin-top: 10px;
      border-bottom: 1px solid #f9f9f9;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
    }

    .vote-option-input {
      height: 20px;
      flex: 1;
      color: #404040;
      font-size: 14px;
    }

    .vote-option-delete {
      font-size: 15px;
      color: #9C9C9C
    }

    .vote-add-option {
      height: 51px;
      display: flex;
      align-items: center;
      color: #404040;

      .vote-option-add-icon {
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: rotate(45deg);
        margin-right: 19px;
      }

      .add-text {
        font-size: 12px;
      }


    }

    .type-box {
      padding-top: 8px;
      padding-bottom: 8px;

      .type-text {
        font-size: 14px;
        line-height: 20px;
        color: #404040;
        margin-right: 10px
      }

      .type-item {
        padding: 6px 10px;
        font-size: 12px;
        color: #9C9C9C;
        border: 1px solid #9C9C9C;
        border-radius: 14px;
        margin-right: 8px
      }
    }


    .end-box {
      padding-top: 6px;
      padding-bottom: 6px;
      margin-top: 9px;
      .type-text {
        font-size: 14px;
        line-height: 20px;
        color: #404040;
        margin-right: 10px
      }

      .end-item {
        padding: 6px 10px;
        font-size: 12px;
        color: #9C9C9C;
        border: 1px solid #9C9C9C;
        border-radius: 14px;
        margin-right: 8px
      }
    }

    .text-active {
      color: #f64 !important;
      border-color: #f64 !important;
    }

  }


</style>